import React, {useEffect, useState} from 'react';
import {Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {student_strings} from "../../../translations/student_translations";
import {resource_strings} from "../../../translations/resource_translations";
import {common_strings} from "../../../translations/common_translations";
import localeHelpers from "../../../helpers/LocaleHelper";
import Label from "reactstrap/es/Label";
import CheckBoxList from "../../Tables/CheckBoxList";
import ResourceApiService from "../../../api/resource-api-service";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const RegularClassTypes = (props) => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
    });

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    const unAssignClassType = (classType) => {
        setShowLoader(true)
        ResourceApiService.removeClientFromClassType(classType.id, props.student.id)
            .then(res => {
                props.onClassTypesUpdated();
                setShowLoader(false);
            })
            .catch((e) => {
                this.props.handleError(e);
                setShowLoader(false);
            });
    };

    const assignClassType = (classType) => {
        setShowLoader(true)
        ResourceApiService.addClientToClassType(classType.id, props.student.id)
            .then(res => {
                props.onClassTypesUpdated();
                setShowLoader(false);
            })
            .catch((e) => {
                this.props.handleError(e);
                setShowLoader(false);
            });
    };

    const handleClassTypeSelected = (checked, id) => {
        const classType = props.classTypes.find(it => it.id === id);

        if (classType) {
            if (checked) {
                assignClassType(classType)
            }
            else {
                unAssignClassType(classType)
            }
        }
    };

    const renderTableData = () => {
        return (props.classTypes || []).map((classType, index) => {
            return (
                <CheckBoxList item={{id: classType.id, label: classType.name}} key={classType.id}
                              selected={(classType.students || []).map((s) => s.id).includes(props.student.id)}
                              handleChange={handleClassTypeSelected}/>
            )
        })
    };

    localize();

    return (
        <>
            <LoadingOverlay
                active={showLoader}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
            <Label className="text-dark">{studentStrings.formatString(studentStrings.regular_classes_expl, props.student.name)}</Label>
            {props.classTypes && props.classTypes.length > 0 &&
                <Table
                    className="align-items-center table-dark table-flush mt-2"
                    responsive
                >
                    <tbody>
                    {renderTableData()}
                    </tbody>
                </Table>
            }
            </LoadingOverlay>
        </>
    );
};

export default RegularClassTypes;